import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Order from '../pages/order/order'
import Stock from '../pages/stock/stock'
import Orders from '../pages/orders/orders'
import Search from "../pages/search/search";
import Strategies from "../pages/strategies/strategies";
import MarketAnalysis from "../pages/marketAnalysis/marketAnalysis";
import BrokerPortfolio from "../pages/brokerPortfolio/brokerPortfolio";
import Stocks from '../pages/stocks/stocks'
import Logout from '../pages/logout/logout'
import Profile from '../pages/profile/profile'
import AccountSessions from '../pages/accountSessions/accountSessions'
import Checkout from '../pages/checkout/checkout'
import NotFound from '../pages/notFound/notFound'
import { Stocks as StocksContext } from '../stocks'
import { StoreContext } from '../store'
import { canManageAccountSessions } from '../pages/accountSessions/accountSessionsPolicy'

const showTradingStrategies =
  process.env.REACT_APP_SHOW_TRADING_STRATEGIES === '1' || process.env.NODE_ENV !== 'production';

const showMarketAnalysis =
  process.env.REACT_APP_SHOW_MARKET_ANALYSIS === '1' || process.env.NODE_ENV !== 'production';

const showBrokerPortfolio =
  process.env.REACT_APP_SHOW_BROKER_PORTFOLIO === '1' || process.env.NODE_ENV !== 'production';

const Private = ({ match: { path }}) => {
  const {store} = React.useContext(StoreContext);
  const showAccountSessions = canManageAccountSessions(store);
  return (
    <StocksContext>
      <Switch>
        <Route
          path={`${path}/profile`}
          component={Profile}
        />
        {showAccountSessions && (
          <Route
            path={`${path}/sessions`}
            component={AccountSessions}
          />
        )}
        <Route
          path={`${path}/search`}
          component={Search}
        />
        {showMarketAnalysis && (
          <Route
            path={`${path}/market-analysis`}
            component={MarketAnalysis}
          />
        )}
        {showTradingStrategies && (
          <Route
            path={`${path}/strategies`}
            component={Strategies}
          />
        )}
        {showBrokerPortfolio && (
          <Route
            path={`${path}/broker-portfolio`}
            component={BrokerPortfolio}
          />
        )}
        <Route
          path={`${path}/orders`}
          component={Orders}
        />
        <Route
          path={`${path}/order/:planId`}
          component={Order}
        />
        <Route
          path={`${path}/checkout/:planId`}
          component={Checkout}
        />
        <Route
          path={`${path}/logout`}
          component={Logout}
        />
        <Route
          path={`${path}/stocks/:page`}
          component={Stocks}
        />
        <Route
          path={`${path}/stocks`}
          component={Stocks}
        />
        <Route
          path={`${path}/stock/:ticker`}
          component={Stock}
        />
        <Route component={NotFound} />
      </Switch>
    </StocksContext>
  );
}

export default Private;
